export const GET_DOMAIN = 'GET_DOMAIN';
export const GET_NAME = 'GET_NAME';
export const GET_PREFACE = 'GET_PREFACE';
export const GET_MENU = 'GET_MENU';
export const GET_CAROUSEL = 'GET_CAROUSEL';
export const IN_HOME = 'IN_HOME';
export const NO_HOME = 'NO_HOME';
export const GET_PAGE = 'GET_PAGE';
export const GET_LIST_POSTS = 'GET_LIST_POSTS';
export const GET_LAST_LIST_POSTS = 'GET_LAST_LIST_POSTS';
export const GET_INTERESTING_LINKS = 'GET_INTERESTING_LINKS';
export const GET_ALL_POSTS = 'GET_ALL_POSTS';
